import { History } from "lucide-react";
import { Container, IconContainer, Mensagem } from "./styles";

export default function HistoricoVazio() {
    return (
        <Container>
            <IconContainer>
                <History size={48} />
            </IconContainer>
            <Mensagem>Nenhum histórico disponível para esta demanda.</Mensagem>
        </Container>
    );
}

